"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = require("../../command-expander");
exports.longHungarianUmlaut = command_expander_1.lookupOrAppend({
    o: "ő",
    u: "ű",
    O: "Ő",
    U: "Ű",
}, "\u030B");
//# sourceMappingURL=long-hungarian-umlaut.js.map